import styled from 'styled-components';

const TabsMenuItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .TabsMenuItem {
    &__icon {
    }

    &__title {
      padding-top: ${(props) => props.title ? 0.4 : 0}rem;
      color: #000;
      font-size: 1.2rem;
    }
  }
`;

export { TabsMenuItemStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
